import { render, staticRenderFns } from "./roleAssignDataPermissions.vue?vue&type=template&id=a1a82290&scoped=true&"
import script from "./roleAssignDataPermissions.vue?vue&type=script&lang=ts&"
export * from "./roleAssignDataPermissions.vue?vue&type=script&lang=ts&"
import style0 from "./roleAssignDataPermissions.vue?vue&type=style&index=0&id=a1a82290&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1a82290",
  null
  
)

export default component.exports